import { graphql } from 'react-relay';

export const ModelGeneration3DModelsQuery = graphql`
    query modelGeneration3DModelsQuery {
        modelGeneration3DModels {
            serviceIDs
            model
            modelName
            maxPromptLength
            supportedModes
            slots
            isDefault
            supportedParameters {
                name
                type
                supportedModes
                isRequired
                defaultValue
                allowedValues
                minValue
                maxValue
            }
        }
    }
`;
